var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.tag,{tag:"tag"},[_vm._v(_vm._s(_vm.v))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }